import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import svg from '../../public/images/shipping-icon.svg';
import { EGROWTHBOOK_FEATURES_FLAGS } from '../../utils/growthbook-constants';

const MessageWrapper = styled.div`
  display: flex;
  column-gap: ${(props) => props.theme.modularScale.eight};
  margin-bottom: ${(props) => props.theme.modularScale.sixteen};
  color: #2b4798;
  font-family: ${(props) => props.theme.font.sans};
  font-size: ${(props) => props.theme.modularScale.fourteen};
  font-style: normal;
  font-weight: 400;
  line-height: ${(props) => props.theme.modularScale.twenty};
`;

const MessageBold = styled.span`
  font-weight: 600;
`;

const ShippingIcon = styled(svg)``;

const FreeShippingMessages = {
  default: ' on orders over $95.',
  itemLevel: ' on this item',
  empty: ''
};

const FreeGroundShipping = ({ className, product, activeVariant, growthbookFeatureFlagValues }) => {
  const [message, setMessage] = useState(FreeShippingMessages.default);

  const { [EGROWTHBOOK_FEATURES_FLAGS.FREE_SHIPPING_ON_ALL_PRODUCTS]: freeShippingOnAllProducts } =
    growthbookFeatureFlagValues;

  useEffect(() => {
    if (freeShippingOnAllProducts) {
      setMessage(FreeShippingMessages.itemLevel);
    } else {
      if (
        product?.free_shipping_eligible &&
        !product?.discontinued &&
        (!activeVariant ||
          (activeVariant?.free_shipping_eligible && activeVariant.in_stock && !activeVariant?.discontinued))
      ) {
        if (product?.ships_free && (!activeVariant || activeVariant?.ships_free)) {
          setMessage(FreeShippingMessages.itemLevel);
        } else {
          setMessage(FreeShippingMessages.default);
        }
      } else {
        setMessage(FreeShippingMessages.empty);
      }
    }
  }, [product, activeVariant]);

  return message ? (
    <MessageWrapper className={className ?? ''}>
      <ShippingIcon />
      <span>
        <MessageBold>Free {freeShippingOnAllProducts ? 'standard' : 'ground'} shipping</MessageBold>
        {message}
      </span>
    </MessageWrapper>
  ) : null;
};

FreeGroundShipping.defaultProps = {
  className: '',
  product: undefined,
  activeVariant: undefined,
  growthbookFeatureFlagValues: {}
};

FreeGroundShipping.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object,
  activeVariant: PropTypes.object,
  growthbookFeatureFlagValues: PropTypes.object
};

FreeGroundShipping.whyDidYouRender = true;

export default FreeGroundShipping;
